exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wf_link_button {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #0353E9;\n}\n.wf_link_button .btn-icon {\n  margin-right: 0.5rem;\n}\n", ""]);

